import { memo } from 'react'
import { Container as MuiContainer, ContainerProps, SxProps } from '@mui/material'
import { containerStyles } from './Container.style'

function Container({ sx, ...props }: ContainerProps) {
  return <MuiContainer sx={[containerStyles.container, sx] as SxProps} {...props} />
}

export default memo(Container)
